/**
 * Backend stores corpus as JSONField; API responses often arrive as a plain object.
 * Legacy paths may still send a JSON string. Normalize to an object or null.
 */
export function getCorpusObject(corpus) {
  if (corpus == null || corpus === "") return null;
  if (typeof corpus === "object") return corpus;
  if (typeof corpus === "string") {
    try {
      return JSON.parse(corpus);
    } catch {
      return null;
    }
  }
  return null;
}

export function getCorpusMostRecent(corpus) {
  const obj = getCorpusObject(corpus);
  const recent = obj?.most_recent;
  return Array.isArray(recent) ? recent : [];
}
